module.exports = __webpack_public_path__ + "img/snkrhud.0c57daf8.png";